export default "__VITE_ASSET__Cv3S5DfP__"